import React from "react";
import { 
    Level, LevelItem, Grid, GridItem, ClipboardCopy, Content, Divider, Tooltip
} from '@patternfly/react-core';
import { Icons } from 'shared/components/Icons/index'

const SftpInfo = ({
  userProfile,
  loading
}) => {
  const sftp_lin_command = `sftp -P 222 ${userProfile.username}@sftp.zspw.pl`
  const winscp = <Content component="a" target="_blank" href="https://winscp.net/download/WinSCP-6.5.6-Setup.exe/download"><small>WinSCP</small></Content>
  return (
    <>
    {/* SFTP */}
    <br />
    <Grid
      hasGutter
      span={12}
        style={{
            fontSize: "13px",
            lineHeight: "1.6"
        }}
    >
      <GridItem>
        <Content component="h6">Przesyłaniie plików</Content>
        <Level>
          {/* OS */}
          <LevelItem>
            <Tooltip content={<div>Windows</div>}>
              {Icons.Windows}
            </Tooltip>
          </LevelItem>
          {/* Host */}
          <LevelItem><small><b>Host:</b></small></LevelItem>
            <LevelItem>
              <ClipboardCopy 
                copyAriaLabel="Copy inline compact example"
                hoverTip="Kopiuj"
                clickTip="Skopiowano"
                variant="inline-compact"
                style={{marginRight: "0px", paddingRight: "0px"}}
              >
                sftp.zspw.pl
              </ClipboardCopy>
            </LevelItem>
            {/* Protocol */}
            <LevelItem><small><b>Protokół:</b></small></LevelItem>
            <LevelItem>
              SFTP
            </LevelItem>
            {/* Port */}
            <LevelItem><small><b>Port:</b></small></LevelItem>
            <LevelItem>222</LevelItem>
            <LevelItem>
              <small><span><b>Aplikacja: </b></span> <span>{winscp}</span></small>
            </LevelItem>
            <Divider />
        </Level>
        <Level>
          {/* OS */}
          <LevelItem>
            <Tooltip content={<div>Linux</div>}>
              {Icons.Linux}
            </Tooltip>
          </LevelItem>
          {/* SFTP Command */}
          <LevelItem><small><b>Polecenie:</b></small></LevelItem>
            <LevelItem>
              <ClipboardCopy 
                copyAriaLabel="Copy inline compact example"
                hoverTip="Kopiuj"
                clickTip="Skopiowano"
                variant="inline-compact"
                style={{marginRight: "0px", paddingRight: "0px"}}
              >
                {sftp_lin_command}
              </ClipboardCopy>
            </LevelItem>
        </Level>
      </GridItem>
    </Grid>
    </>
  );
};

export default SftpInfo;